export default "__VITE_ASSET__6c6b1587__"